import { useState } from "react"
import { LocalStorageHelper } from "common/helpers"

// https://usehooks.com/useLocalStorage
export function useLocalStorage(key, initialValue) {
    const [storedValue, setStoredValue] = useState(() => {
        if (typeof window === "undefined") {
            return initialValue
        }
        try {
            return LocalStorageHelper.getItem(key)
        } catch (error) {
            console.log(error)
            return initialValue
        }
    })

    const setValue = value => {
        try {
            const valueToStore =
                value instanceof Function ? value(storedValue) : value
            setStoredValue(valueToStore)
            if (typeof window !== "undefined") {
                LocalStorageHelper.setItem(key, valueToStore)
            }
        } catch (error) {
            console.log(error)
        }
    }
    return [storedValue, setValue]
}
